<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="600px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="130px" :rules="rules">
          <el-form-item label="所属年份" prop="iYear">
            <el-date-picker
              v-model="form.iYear"
              format="yyyy"
              value-format="yyyy"
              type="year"
              style="width: 100%"
              placeholder="请选择年份"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="供热面积（㎡）" prop="HeatingArea">
            <el-input-number
              v-model="form.HeatingArea"
              :precision="2"
              :step="0.1"
              :min="0"
              style="width: 100%; text-align-last: left"
              controls-position="right"
              @change="changeHeatingArea"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="价格" prop="Price">
            <el-input-number
              v-model="form.Price"
              :precision="2"
              :step="0.1"
              :min="0"
              style="width: 100%; text-align-last: left"
              controls-position="right"
              @change="changePrice"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="金额" prop="Amount">
            <el-input
              v-model="form.Amount"
              placeholder="自动计算金额"
              disabled
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="备注" prop="Remarks">
            <el-input
              v-model="form.Remarks"
              placeholder=""
              type="textarea"
              rows="3"
              resize="none"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="货区类型">
            <SelectDicValue
              ref="SelectDicValue"
              code="StorAreaType"
              v-model="form.Type"
            ></SelectDicValue>
          </el-form-item> -->
          <!-- <el-form-item label="性别" prop="Sex">
            <el-radio-group v-model="form.Sex">
              <el-radio :label="0">女</el-radio>
              <el-radio :label="1">男</el-radio>
            </el-radio-group>
          </el-form-item> -->

          <!-- <el-form-item label="所属角色">
            <el-select
              v-model="form.RoleIdList"
              placeholder="请选择角色"
              multiple
              filterable
            >
              <el-option
                v-for="item in RoleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.RoleName"
                >{{ item.RoleName }}</el-option
              >
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Token from '@/utils/cache/TokenCache.js'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      form: {
        iYear: '',
        HeatingArea: '',
        Price: '',
        Amount: '',
      },
      rules: {
        iYear: [{ required: true, message: '请请选择年份', trigger: 'change' }],
        HeatingArea: [
          { required: true, message: '请输入供热面积', trigger: 'blur' },
        ],
        Price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        Amount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
      },
      drawer: false,
    }
  },
  props: {},
  components: {},
  methods: {
    changeHeatingArea(currentValue, oldValue) {
      console.log(currentValue, oldValue, '面积')
      let a = Number(this.form.HeatingArea || 0)
      let b = Number(this.form.Price || 0)
      this.form.Amount = Number(this.$number.mut(a, b)).toFixed(2)
      console.log(this.form.Amount, '金额')
    },
    changePrice(currentValue, oldValue) {
      console.log(currentValue, oldValue, '价格')
      let a = Number(this.form.HeatingArea || 0)
      let b = Number(this.form.Price || 0)
      this.form.Amount = Number(this.$number.mut(a, b)).toFixed(2)
      console.log(this.form.Amount, '金额')
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/Base/HeatingConsumption/SaveData', this.form)
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}) {
      this.drawer = true
      // this.getRoleList();
      this.form = {
        iYear: moment().format('YYYY'),
        HeatingArea: '',
        Price: '',
        Amount: '',
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base/HeatingConsumption/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
